var React = require('react');

function ChipIo (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1149 -483) rotate(90)"},[React.createElement("rect",{"width":"7","height":"8","transform":"translate(483 1081)","fill":"#a0a09f","key":0}),React.createElement("rect",{"width":"7","height":"8","transform":"translate(483 1101)","fill":"#a0a09f","key":1}),React.createElement("rect",{"width":"7","height":"8","transform":"translate(483 1121)","fill":"#a0a09f","key":2}),React.createElement("rect",{"width":"7","height":"8","transform":"translate(483 1141)","fill":"#a0a09f","key":3})]));
}

ChipIo.defaultProps = {"width":"68","height":"7","viewBox":"0 0 68 7"};

module.exports = ChipIo;

ChipIo.default = ChipIo;
